import { render } from "./RPK.vue?vue&type=template&id=249fd68c&scoped=true&ts=true"
import script from "./RPK.vue?vue&type=script&lang=ts"
export * from "./RPK.vue?vue&type=script&lang=ts"

import "./RPK.vue?vue&type=style&index=0&id=249fd68c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249fd68c"]])

export default __exports__